Monitoring.Dashboard ||= {}

class Monitoring.Dashboard.SelectableOptionsView extends Backbone.View
  template: JST['backbone/templates/monitoring/selectable_options']
  
  #events:
  #  'click .export-confirm' : 'onClickExport'
  #  'click .exportable-fields-option' : 'toggleExportableFieldsOption'

  initialize: (@options_fields = {}) =>
    @options_fields = @options_fields

  render: =>
    @$el.html(@template({options_fields: @options_fields, selected_by_default: false }))
    @

  toggleExportableFieldsOption: ()=>
    if @$( ".exportable-fields-list:first" ).is( ":hidden" )
      @$('.caret-hide-unhide').removeClass("fa fa-caret-down")
      @$('.caret-hide-unhide').addClass("fa fa-caret-up")
      @$('.exportable-fields-list').slideDown( "fast" )
    else
      @$('.caret-hide-unhide').removeClass("fa fa-caret-up")
      @$('.caret-hide-unhide').addClass("fa fa-caret-down")
      @$('.exportable-fields-list').slideUp( "fast" )

  isSelected: (field_name)=>
    @$('#'+field_name)[0].checked

  addSection: (fields, section_title, default2) =>
    p1 = @first_part(fields)
    p2 = @last_part(fields)
    template = @anotherTemplate({title: section_title, p1: p1, p2: p2, default2: default2})
    section = $('<div></div>')
    section.html(template)
    @$('.first-exportable-fields-list').append(section)

  first_part:(user_profile_attributes)=>
    keys = Object.keys(user_profile_attributes)
    m = Math.round (keys.length/2)
    p1 = keys.slice(0, m)
    h = {}
    _.map(p1, (key) =>
        h[key] = (user_profile_attributes[key])
    )
    h

  last_part:(user_profile_attributes) =>
    keys = Object.keys(user_profile_attributes)
    m = Math.round (keys.length/2)
    p2 = keys.slice(m , keys.length)
    h = {}
    _.map(p2, (key) =>
        h[key] = (user_profile_attributes[key])
    )
    h

  onClickExport: (event) =>
    event.stopPropagation()
    @trigger('on-export-confirm')
    swal("Export started!", "We will send you an email once it's completed", "success")

  showModal: =>
    @$('#exportable-fields-modal').modal()

  _selectedFromHash: (selectable_hash) =>
    h = {}
    _.map(selectable_hash, (value, key) =>
      if @isSelected(key)
        h[key] = true
      else
        h[key] = false
    )
    h